import React from 'react';
import ProductsData from '../data/productsInfo.json';
import { useParams, Navigate } from 'react-router-dom';
import logo from '../images/glometal-logo.PNG';
import {
  TypeMap, CoatingTypes, TrayHeights,
  TrayThicknesses, TrayWidths, TechTable, AvailabilityTable
} from '../utils/constants';
import ContentTooltip from "../utils/ContentTooltip";
import FaIcon from '../utils/FaIcon';

export const importAll = (requireContext) => {
  return requireContext.keys().map(requireContext);
};

const ProductInfo = () => {
  const { type, code } = useParams();

  const [height, setHeight] = React.useState('50');
  const [width, setWidth] = React.useState('50');
  const [thickness, setThickness] = React.useState('N');
  const [coating, setCoating] = React.useState('HD');
  const getSrc = (code) => {
    try {
      return require(`../images/products/${type}-${code}.png`);
    } catch (error) {
      return logo;
    }
  }
  const product = ProductsData.find(item => item.code === code);
  const mainProduct = ProductsData.find(item => item.code === TypeMap[type]);
  if (!product || !mainProduct) {
    return <Navigate to="/404" replace />;
  }
  const files = importAll(require.context("../docs/TDS", true, /\.*/))
    .filter((file) => product?.techSpecDocs && product?.techSpecDocs[mainProduct?.code || 'LCT'].includes(file.split('/').pop().split('.')[0]))
  const getIframes = () => files.map((file, index) => (<div className='transparent-card left-card'><h3>{file.split('/').pop().split('.')[0]}</h3><iframe key={index} src={`${file}#zoom=fitW`} title={`Document ${index + 1}`} style={{ width: '100%', height: '875px', border: 'none' }} /></div>))

  return (
    <div className='productinfo-page'>
      <div className='cards-wrapper'>
        <div className='productinfo-card'>
          <h3 style={{ color: "#e47931" }}>Product Information</h3>
          <h1>{product.title}</h1>
          <p style={{ textAlign: 'justify' }}>{product.description}</p>

          <div className='product-categories'>
            <h2>Product Ordering Code:</h2>
            <ContentTooltip tooltip='GM stands for Glometal'>GM</ContentTooltip>
            <ContentTooltip tooltip={`${mainProduct.code} stands for ${mainProduct.title}`}>{mainProduct.code}</ContentTooltip>
            <ContentTooltip tooltip='height of side collar in mm'> <span>{height}</span> </ContentTooltip>
            <ContentTooltip tooltip='thickness of tray in mm'> <span >{thickness}</span> </ContentTooltip>
            <ContentTooltip tooltip='width of tray in mm'> <span >{width}</span> </ContentTooltip>
            {mainProduct.code !== product.code &&
              <ContentTooltip tooltip={`code for ${product.title}`}> <span >{product.code}</span> </ContentTooltip>
            }
            <ContentTooltip tooltip='coating type'> <span >{coating}</span> </ContentTooltip>
            <div style={{ color: "#e47931" }}><small><i>Hover on each segment to know more details</i></small></div>
            <p>Select different specification below as per requirement to change the product ordering code</p>
            <div className='specifics-wrapper'>
              <div>
                <label>
                  <FaIcon icon='up-down' />
                  Height</label>

                <select className='select' value={height} onChange={(e) => setHeight(e.target.value)}>
                  {
                    TrayHeights.map((height) => (
                      <option key={height.code} value={height.code}>
                        {height.name}
                      </option>
                    ))
                  }
                </select>
              </div>
              <div>
                <label>
                  <FaIcon icon='left-right' />
                  Width</label>
                <select className='select' value={width} onChange={(e) => setWidth(e.target.value)}>
                  {
                    TrayWidths.map((width) => (
                      <option key={width.code} value={width.code}>
                        {width.name}
                      </option>
                    ))
                  }
                </select>
              </div>
              <div>
                <label>
                  <FaIcon icon='weight-hanging' />
                  Thickness</label>
                <select className='select' value={thickness} onChange={(e) => setThickness(e.target.value)}>
                  {
                    TrayThicknesses.map((thickness) => (
                      <option key={thickness.code} value={thickness.code}>
                        {thickness.name}
                      </option>
                    ))
                  }
                </select>
              </div>
              <div>
                <label>
                  <FaIcon icon='feather-pointed' />
                  Coating</label>
                <select className='select' value={coating} onChange={(e) => setCoating(e.target.value)}>
                  {
                    CoatingTypes.map((type) => (
                      <option key={type.code} value={type.code}>
                        {type.name}
                      </option>
                    ))
                  }
                </select>
              </div>
            </div>
          </div>
          {TechTable[product?.tableCategories?.TechTable || 'cat1']}
        </div>
        <div>
          <img src={getSrc(code)} alt={product.title} />
          {AvailabilityTable[product?.tableCategories?.AvailabilityTable || 'cat1']}
        </div>

      </div>
      {files.length > 0 &&
        <div className='transparent-card-wrapper full-width'>
          <div className='transparent-card center-card'>
            <h3 style={{ color: "#e47931" }}>View or Download our Technical Data Sheet</h3>
            <h2>Technical specifications</h2>
          </div>

          {getIframes()}

        </div>}
    </div>
  );
};

export default ProductInfo;